// src/components/ErrorBoundary/ErrorModal.js
import { Row, Col, Modal } from "react-bootstrap";
import "./ErrorModal.css";

function ErrorModal({ setIsOpen, isOpen, onRetry }) {
  return (
    <Row className="btn-page">
      <Col sm={12}>
        <Modal
          size="ml"
          show={isOpen}
          onHide={() => {
            setIsOpen(false);
          }}
          centered
          className="error-modal-custom"
        >
          <Modal.Header closeButton className="error-modal-header">
            <Col className="text-center w-100">
              <div className="error-icon-container">
                <svg
                  className="error-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M12 8V12M12 16H12.01"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <h3 className="error-title">Algo salió mal</h3>
            </Col>
          </Modal.Header>
          <Modal.Body className="error-modal-body">
            <div className="error-message-container">
              <p className="error-message">
                Hubo un problema al cargar esta página.
              </p>
              <p className="error-submessage">
                Por favor, intenta nuevamente o contacta con soporte si el problema persiste.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer className="error-modal-footer">
            <button onClick={onRetry} className="retry-button">
              <svg
                className="retry-icon"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 12C4 7.58172 7.58172 4 12 4C14.5264 4 16.7792 5.17108 18.2454 7M20 12C20 16.4183 16.4183 20 12 20C9.47362 20 7.22082 18.8289 5.75463 17"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M18 3V7H14M6 21V17H10"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Intentar nuevamente
            </button>
          </Modal.Footer>
        </Modal>
      </Col>
    </Row>
  );
}

export default ErrorModal;

// // src/components/ErrorBoundary/ErrorModal.js
// import { Row, Col, Modal } from "react-bootstrap";

// function ErrorModal({ setIsOpen, isOpen, onRetry }) {
//   return (
//     <Row className="btn-page">
//       <Col sm={12}>
//         <Modal
//           size="ml"
//           show={isOpen}
//           onHide={() => {
//             setIsOpen(false);
//           }}
//         >
//           <Modal.Header closeButton>
//             <Col>
//               <div>
//                 <h3>Algo salió mal.</h3>
//               </div>
//             </Col>
//           </Modal.Header>
//           <Modal.Body>
//             <div>
//               <h5>Hubo un problema al cargar esta página.</h5>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//           <button 
//             onClick={onRetry} // Usamos la función onRetry proporcionada por el ErrorBoundary
//             style={{
//               padding: "8px 16px",
//               backgroundColor: "#4285f4",
//               color: "white",
//               border: "none",
//               borderRadius: "4px",
//               cursor: "pointer"
//             }}
//           >
//             Intentar nuevamente
//           </button>
//           </Modal.Footer>
//         </Modal>
//       </Col>
//     </Row>
//   );
// }

// export default ErrorModal;